import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { FiHome } from "react-icons/fi";
import "./style.scss";

export const FloatingHomeButton = () => {
  const { isLogged } = useAuth();
  const navigate = useNavigate();

  if (isLogged) return null;

  return (
    <button className="floating-home-button" onClick={() => navigate("/")}>
      <FiHome size={24} color="#fff" />
    </button>
  );
};
